var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"empty-cart-view"},[_c('h2',{staticClass:"is-size-large"},[_vm._v("您的購物車還沒有商品。")]),_c('p',[_vm._v("\n    快到我們的"),_c('b-link',{attrs:{"to":{ name: 'home' }}},[_vm._v("首頁")]),_vm._v("來逛逛，把購物車裝滿吧！\n  ")],1)])}
var staticRenderFns = []

export { render, staticRenderFns }